// extracted by mini-css-extract-plugin
export default {"Container":"kCA0cUQZgzOPNTxMZiY7","Logo":"sbx7PW9qtNaUdrUkdfMP"};